// extracted by mini-css-extract-plugin
module.exports = {"error-message":"b7635b5199--error-message--CGKoB"};